<template>
  <div id="page-container"></div>
</template>

<script>
import { useCommonStore } from "@/stores/CommonStore.ts";
import { mapActions } from "pinia";
export default {
  name: "NYFormPage",
  props: {
    sample_id: String,
    accession_id: String,
    jwtToken: String,
  },
  mounted() {
    this.setSampleId(this.sample_id);
    this.setAccessionId(this.accession_id);
    this.setJwtToken(this.jwtToken);
    this.$router.push("/ny_form");
  },
  methods: {
    ...mapActions(()=>useCommonStore(), ["setSampleId", "setAccessionId", "setJwtToken"]),
  },
};
</script>
